import { render, staticRenderFns } from "./Sk00701Detail.vue?vue&type=template&id=3ab8b488&scoped=true"
import script from "./Sk00701Detail.vue?vue&type=script&lang=js"
export * from "./Sk00701Detail.vue?vue&type=script&lang=js"
import style0 from "./Sk00701Detail.vue?vue&type=style&index=0&id=3ab8b488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab8b488",
  null
  
)

export default component.exports